/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Loadingattempt1Inputs */

const zh_learn_loadingattempt1 = /** @type {(inputs: Learn_Loadingattempt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载作答记录中...`)
};

const en_learn_loadingattempt1 = /** @type {(inputs: Learn_Loadingattempt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading study attempt...`)
};

const es_learn_loadingattempt1 = /** @type {(inputs: Learn_Loadingattempt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando intento de estudio...`)
};

/**
* | output |
* | --- |
* | "Loading study attempt..." |
*
* @param {Learn_Loadingattempt1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_loadingattempt1 = /** @type {((inputs?: Learn_Loadingattempt1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Loadingattempt1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_loadingattempt1(inputs)
	if (locale === "en") return en_learn_loadingattempt1(inputs)
	return es_learn_loadingattempt1(inputs)
});
export { learn_loadingattempt1 as "learn_loadingAttempt" }